import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/ReportSubmissionComments'
import { localized } from '@/decorators/localized'
import EntityComments from '@/components/comments/EntityComments'

@localized()
class ReportSubmissionComments extends React.Component {
  render () {
    return <EntityComments {...this.props} showExternalVisibilityCheckbox={this.props.showExternalVisibilityCheckbox} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    entityComments: state.reportSubmissionComments,
    author: state.identity.user.profile.name,
    ...ownProps
  }
}

const mapDispatchToProps = {
  getComments: actionCreators.getComments,
  addComment: actionCreators.addComment
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportSubmissionComments)



// WEBPACK FOOTER //
// ./src/components/reporting/reportSubmissionComments.js